PJQ.progress = {};

PJQ.progress.ProgressBar = class {
	constructor($el, options = {}) {
		this.$outer = $el;
		this.options = _.defaults(options, {
			isStriped: false,
			height: 20,
			width: 'auto',
			isShowPercentage: false,
			progress: 0,
			borderRadius: null
		});

		if (this.$el != null && this.$el.length > 0) {
			this.renderProgressBar();
		}
	}

	makeProgressBar() {
		let colorClass = this.options.colorClass ?? this.getCompletionColorClass();
		let $res = $('<div>', {
			class: 'progress',
			style: `height: ${this.options.height}px; width: ${typeof this.options.width === 'number' ? `${this.options.width}px` : this.options.width}; border-radius: ${this.options.borderRadius ?? '.25rem'};`
		});
		$res.append($('<div>', {
			class: 'progress-bar font-weight-light fs-14 bg-' + colorClass + ' text-' + (colorClass === 'warning' ? 'dark' : 'light'),
			role: 'progressbar',
			style: 'width:' + this.options.progress + '%;'
		}).text(this.options.isShowPercentage ? this.options.progress + '%' : ''));
		return $res;
	}

	getCompletionColorClass () {
		let textClass = 'danger';
		if (this.options.progress === 100)
			textClass = 'success';
		else if (this.options.progress > 60)
			textClass = 'warning';

		return textClass;
	}

	renderProgressBar() {
		if (_.size(this.$el) > 0) {
			this.$el.remove();
		}
		this.$el = this.makeProgressBar();

		this.$outer.append(this.$el);
	}

	updateProgress(progress = 0, colorClass = PJQ.views.prequal.PrequalEditor.prototype.getCompletionColorClass(progress)) {
		this.options = _.defaults({
			progress: progress,
			colorClass: colorClass
		}, this.options);
		this.renderProgressBar();
	}
};